import React from 'react'
import Select from './Select'

const Planned = () => {
  return (
    <div>
      <h2>
        Planned
      </h2>
      <Select/>
      </div>
  )
}

export default Planned